// Locale-aware formatting via the Intl API. Uses the active i18n language so
// currency, dates, times and numbers automatically localize per user.
import i18n from "@/i18n";
import { langMeta } from "@/i18n/languages";

function activeLocale() {
  return langMeta((i18n.language || "en").split("-")[0]).locale;
}

export function formatCurrency(amount, currency, opts = {}) {
  const meta = langMeta((i18n.language || "en").split("-")[0]);
  try {
    return new Intl.NumberFormat(meta.locale, {
      style: "currency",
      currency: currency || meta.currency,
      ...opts,
    }).format(amount);
  } catch {
    return `${amount}`;
  }
}

export function formatNumber(value, opts = {}) {
  try {
    return new Intl.NumberFormat(activeLocale(), opts).format(value);
  } catch {
    return `${value}`;
  }
}

export function formatDate(value, opts = { dateStyle: "medium" }) {
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return "";
  try {
    return new Intl.DateTimeFormat(activeLocale(), opts).format(d);
  } catch {
    return d.toLocaleString();
  }
}

export function formatDateTime(value) {
  return formatDate(value, { dateStyle: "medium", timeStyle: "short" });
}
